import React, { useEffect, useState } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { useApplicationCommon } from "../../utils/ApplicationCommon";
import { Link } from "react-router-dom";

const GNBPURE06003S = () => {
  const { doAction } = useApplicationCommon();            // ✅ `doAction`만 사용
  const [isDepthOpen, setIsDepthOpen] = useState(false);  // depth2 메뉴 열림 상태
  const [empList, setEmpList] = useState([]);             // 채용공고 목록 조회
  const [pagination, setPagination] = useState({ pageNo: 1, prevYn: "N", nextYn: "N", startPage: 1, endPage: 1 });
  const [statusType, setStatusType] = useState("1");      // 모집상태 기본값 : 전체

  // ✅ 최초 조회
  useEffect(() => {
    goSearch();
  }, [statusType]);

  // ✅ 채용공고 목록 조회
  const goSearch = (pageNo = 1) => {
    const actionForm = {
      txGbnCd: "recruitList",
      pageNo: pageNo,
      statusType: statusType
    };

    doAction("COM0004SC", actionForm, (resData) => {
      if (resData.APP_HEADER.respCd === "N00001") {
        setEmpList(resData.LIST || []);
        setPagination({
          pageNo: resData.pageNo,
          prevYn: resData.prevYn,
          nextYn: resData.nextYn,
          startPage: resData.startPage,
          endPage: resData.endPage,
        });
      }
    });
  };

  // ✅ 모집상태 변경
  const changeTab = (newTab) => {
    setStatusType(newTab);
  };

  return (
    <CommonLayout>
      <CommonMenu />

      <div id="contents" className="container">

        <div className="sub-title bg-type06">
          <h2>인재 채용</h2>
        </div>

        <div className="location_wrap"
          onClick={() => setIsDepthOpen(!isDepthOpen)}>
          <ul className="depth1">
            <li><Link to="/">home</Link></li>
            <li><Link to="/" onClick={(e) => e.preventDefault()}>채용공고<span></span></Link>
              <ul className="depth2" style={{ display: isDepthOpen ? "block" : "none" }}>
                <li><Link to="/GNBPURE06001S">인재상</Link></li>
                <li><Link to="/GNBPURE06002S">복리후생</Link></li>
                <li><Link to="/GNBPURE06003S">채용공고</Link></li>
              </ul>
            </li>
          </ul>
        </div>
        <div id="cont" className="cont">
          <div className="inner">
            
            <h3>채용공고</h3>
            <h2>당신의 도전이 새로운 미래를 만듭니다.</h2>
            
            {/* 탭 메뉴 */}
            <div className="tabsRcrt ty02">
              <div className="tab-item col03">
                <button className={statusType === "1" ? "on" : ""} onClick={() => changeTab("1")}>전체</button>
                <button className={statusType === "2" ? "on" : ""} onClick={() => changeTab("2")}>진행중</button>
                <button className={statusType === "3" ? "on" : ""} onClick={() => changeTab("3")}>마감</button>
              </div>
            </div>

            {/* 채용 공고 리스트 */}
            <ul className="recruit-wrap recruit-list" id="resultList">
              {empList.length > 0 ? (
                empList.map((employment, index) => (
                  <li className="empList" key={index}>
                    <Link to={`/GNBPURE06004S?linkServiceCd=COM0004SC&txGbnCd=recruitDetail&empt_no=${employment.empt_no}`}>
                      <p>{employment.empt_ttl}</p>
                      <span className={`in-progress ${employment.status === "마감" ? "finished" : ""}`}>
                        {employment.status}
                      </span>
                      <span className="divide">·</span>
                      <span>
                        {employment.empt_str_dt.substring(0, 4)}-{employment.empt_str_dt.substring(4, 6)}-{employment.empt_str_dt.substring(6, 8)} 
                        ~ 
                        {employment.empt_end_dt.substring(0, 4)}-{employment.empt_end_dt.substring(4, 6)}-{employment.empt_end_dt.substring(6, 8)}
                      </span>
                    </Link>
                  </li>
                ))
              ) : (
                <li className="empList-None">
                  <p>함께할 새로운 인재를 기다립니다. 다음 채용공고를 기대해 주세요!</p>
                </li>
              )}
            </ul>

            {/* 페이지네이션 */}
            <ul className="boardPage">
              {pagination.prevYn === "Y" && (
                <li>
                  <button onClick={() => goSearch(pagination.pageNo - 1)} title="이전페이지">
                    ⬅ 이전
                  </button>
                </li>
              )}

              {Array.from({ length: pagination.endPage - pagination.startPage + 1 }, (_, i) => pagination.startPage + i).map((num) => (
                <li key={num} className={pagination.pageNo === num ? "on" : ""}>
                  <button onClick={() => goSearch(num)}>{num}</button>
                </li>
              ))}

              {pagination.nextYn === "Y" && (
                <li>
                  <button onClick={() => goSearch(pagination.pageNo + 1)} title="다음페이지">
                    다음 ➡
                  </button>
                </li>
              )}
            </ul>

          </div>
        </div>
      </div>
      <CommonFooter />
    </CommonLayout>
  );
};

export default GNBPURE06003S;